import type React from "react";
import { useEffect, useState } from "react";
// Import Markdown content using Vite's raw loader
import privacyMarkdown from "../../../../PRIVACY_POLICY.md?raw";
import termsMarkdown from "../../../../TERMS_OF_SERVICE.md?raw";
import { renderMarkdown } from "../../../utils/markdown";
import { Modal } from "./Modal";

export type LegalType = "terms" | "privacy";

interface LegalModalProps {
	isOpen: boolean;
	onClose: () => void;
	type: LegalType;
}

export const LegalModal: React.FC<LegalModalProps> = ({
	isOpen,
	onClose,
	type,
}) => {
	const [content, setContent] = useState("");
	const title = type === "terms" ? "利用規約" : "プライバシーポリシー";

	useEffect(() => {
		const rawContent = type === "terms" ? termsMarkdown : privacyMarkdown;
		// The renderMarkdown utility expects markdown string and renders basic structure
		setContent(renderMarkdown(rawContent, 4));
	}, [type]);

	if (!isOpen) return null;

	return (
		<Modal title={title} isOpen={isOpen} onClose={onClose}>
			<div className="flex flex-col gap-4 max-h-[70dvh] overflow-hidden">
				<div
					className="overflow-y-auto pr-2 pb-4 prose prose-invert prose-sm max-w-none 
                    prose-headings:text-text-main prose-strong:text-text-main prose-li:text-text-dim
                    prose-p:text-text-dim prose-blockquote:text-text-dim"
					// biome-ignore lint/security/noDangerouslySetInnerHtml: Content is from local markdown files
					dangerouslySetInnerHTML={{ __html: content }}
				/>
				<div className="flex justify-end pt-4 border-t border-border-main shrink-0">
					<button
						type="button"
						className="px-6 py-2 bg-slate-700 text-text-main rounded-lg font-semibold hover:bg-slate-600 transition focus-visible:ring-2 focus-visible:ring-primary focus-visible:outline-none active:scale-95"
						onClick={onClose}
					>
						閉じる
					</button>
				</div>
			</div>
		</Modal>
	);
};
